var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoMensajeErrorItal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.12px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: red;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15,
    cy: 15,
    r: 14.34
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.05,10.61l-10.1,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.05,20.71L9.95,10.61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoMensajeErrorItal);
export default __webpack_public_path__ + "static/media/IconoMensajeErrorItal.d1b8298351354062668aed090ab2059e.svg";
export { ForwardRef as ReactComponent };